import { TextField } from '@mui/material';
import ReactInputMask from 'react-input-mask';

interface Props {
  label: string;
  value: string;
  name: string;
  className?: string;
  error?: any;
  hasError?: boolean;
  handleBlur?: (e: any) => void;
  handleChange?: (e: any) => void;
  disabled?: boolean;
  required?: boolean;
  setMessage?: string
}

export const InputCEP = ({
  label,
  value,
  name,
  className,
  error,
  hasError,
  handleBlur,
  handleChange,
  disabled,
  required,
  setMessage = '',
}: Props) => {

 // Função que altera a mensagem de erro do 'required'
 const handleInvalid = (e: React.FormEvent<HTMLInputElement>) => {
  const inputElement = e.target as HTMLInputElement;
  if (required && value === '') {
    //e.preventDefault(); // Evitar que o navegador mostre a mensagem padrão
    // Definir a mensagem customizada
    inputElement.setCustomValidity(setMessage);
   } else {
    inputElement.setCustomValidity('');
  }
};

  return (
    <ReactInputMask
      disabled={disabled}
      mask='99.999-999'
      maskChar=' '
      onBlur={handleBlur}
      value={value}
      onChange={handleChange}
    >
      {/*// @ts-expect-error - .*/}
      {() => (
        <TextField
          size='small'
          disabled={disabled}
          label={label}
          InputLabelProps={{ shrink: true }}
          className={className}
          error={hasError}
          helperText={error}
          name={name}
          required={required}
          onInvalid={handleInvalid}
        />
      )}
    </ReactInputMask>
  );
};
